import http from '../../http'

let getEhrOrgList = (data) => {
  return http.get('opservice/sea/corp', data)
}

let getEhrOrgFlag = (data) => {
  return http.get('opservice/sea/crop_ehr', data)
}

let getPersonList = (data) => {
  return http.get('opservice/sea/psn', data)
}

let relationEhrOrg = (data) => {
  return http.post('opservice/org/set_sea', data)
}

let cannelEhrOrg = (data) => {
  return http.post('opservice/org/unset_sea', data)
}
let lookCardDetail = (data) => {        //查看公司卡片详情
  return http.get('opservice/card/v2/org', data)
}
let saveCardSetting = (data) => {     //设置公司卡片详情
  return http.post('opservice/card/v2/org', data)
}
export default {
  ehr: {
    psnList: getPersonList,
    orgList: getEhrOrgList,
    orgFlag: getEhrOrgFlag,
    relationOrg: relationEhrOrg,
    cannelEhrOrg: cannelEhrOrg,
    businessDetail: lookCardDetail,
    saveCardSetting: saveCardSetting,
  },
  getEnterpriseInfo: () => {
    return http.post('opservice/enterprise/info', {})
  }, //查询企业基本信息
  saveEnterpriseInfo: (data) => {
    return http.post('opservice/enterprise/save', data)
  }, //保存企业基本信息
  getOrgs: () => {
    return http.post('opservice/org/tree')
  }, // 根据级数获取组织
  addOrg: (data) => {
    return http.post('opservice/org/create', data)
  }, // 创建组织
  updateOrg: (data) => {
    return http.post('opservice/org/update', data)
  }, // 更新组织
  deleteOrg: (data) => {
    return http.get('opservice/org/delete', data)
  }, // 删除组织
  findOneOrg: (data) => {
    return http.get('opservice/org/findone', data)
  }, // 获取单个组织信息
  childsOrg: (data) => {
    return http.get('opservice/org/childs', data)
  }, // 获取组织机构节点数据
  updatePerson: (data) => {
    return http.post('opservice/enterpriseadmin/update', data)
  }, // 更新人员信息
  changePassword: (data) => {
    return http.post('opservice/enterpriseadmin/changePasswd', data)
  },//修改账号密码
  certification: (data) => {
    return http.post('opservice/org/set_contacts', data)
  }, //留资设置
  getcertification: (orgId) => {
    return http.get('opservice/org/get_contacts?orgId=' + orgId)
  },
  changeOrg: (data) => {
    return http.post('/opservice/enterpriseadmin/changeOrg', data)
  }
}
